import {
  Flex,
  Icon,
  Link,
  PlacementWithLogical,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { FaTimesCircle } from "react-icons/fa";
import { ProjectDocument, SupportedChains } from "~/core/types";
import RequiredIndicator from "../RequiredIndicator";

export default function NftRequirement({
  project,
  isTooltipOpen,
  tooltipPosition,
}: {
  project: ProjectDocument;
  isTooltipOpen: boolean;
  tooltipPosition?: PlacementWithLogical;
}) {
  if (!project?.wallet?.isNftRequired) {
    return null;
  }

  const nftChain =
    (project?.wallet?.nftCollection?.chain as SupportedChains) || project.chain;
  const data = project?.wallet?.nftCollection;

  return (
    <Tooltip
      label={
        <>
          {nftChain === "solana"
            ? "You must hold this SOLANA NFT"
            : `You must hold a ${nftChain.toUpperCase()} token from`}{" "}
          <Link target={"_blank"} href={data?.url}>
            <b>&quot;{data?.name}&quot;</b>
          </Link>
        </>
      }
      pointerEvents={"all"}
      isOpen={isTooltipOpen}
      padding={4}
      fontSize={"md"}
      backgroundColor={"red.500"}
      placement={tooltipPosition}
      hasArrow
    >
      <Flex direction="row" alignItems="center" mb={2}>
        <Text fontSize="13" color={"descText"}>
          {nftChain === "solana"
            ? "You must hold this Solana NFT"
            : `Hold a ${nftChain.toUpperCase()} token from`}{" "}
          <Link target={"_blank"} href={data?.url} color="#2CBBDB">
            <b>{data?.name}</b>{" "}
            {isTooltipOpen && (
              <Icon
                ml="2"
                as={FaTimesCircle}
                color="#CD4A38"
                display="inline-block"
              />
            )}
          </Link>
        </Text>
        <RequiredIndicator required={!project.wallet?.isNftOptional} />
      </Flex>
    </Tooltip>
  );
}
